(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["architectural-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('psh-wall-estimator')) {
  customElements.define('psh-wall-estimator', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      this.config=JSON.parse(this.querySelector('[data-estimator-config]').textContent);
      this.form=this.querySelector('form');
      this.button=this.querySelector('[data-submit]');
      this.status=this.querySelector('[data-status]');
      this.form.addEventListener('input',()=>this.update());
      this.form.addEventListener('submit',event=>this.add(event));
      this.update();
    }
    update() {
      const e=this.form.elements;
      const length=Number(e.namedItem('length').value),height=Number(e.namedItem('height').value);
      const area=length*height,pieces=Math.ceil(area*4.5*(1+Number(e.waste.value)));
      const tubes=Math.ceil(pieces/30);
      this.querySelector('[data-length-output]').textContent=length+' ft';
      this.querySelector('[data-height-output]').textContent=height+' ft';
      this.querySelector('[data-area]').textContent=area.toLocaleString();
      this.querySelector('[data-pieces]').textContent=pieces;
      this.querySelector('[data-tubes]').textContent=tubes;
      const candidates=(this.config.materials[e.material.value]||[]).filter(v=>v.available).map(v=>{
        const count=v.title==='Single'?1:Number((v.title.match(/Pack of (\d+)/)||[])[1]);
        const quantity=Math.ceil(pieces/count);
        return {...v,count,quantity,cost:quantity*v.price};
      }).filter(v=>Number.isFinite(v.cost)&&v.count>0).sort((a,b)=>a.cost-b.cost||a.quantity*a.count-b.quantity*b.count);
      const selected=candidates[0],glue=this.config.adhesive;
      const valid=selected&&(!e.adhesive.checked||(glue&&glue.available));
      this.button.disabled=!valid||this.busy;
      if(!valid){this.querySelector('[data-selection]').textContent=this.config.text.unavailable;this.querySelector('[data-total]').textContent='';this.items=[];return;}
      this.items=[{id:selected.id,quantity:selected.quantity}];
      if(e.adhesive.checked)this.items.push({id:glue.id,quantity:tubes});
      const price=selected.cost+(e.adhesive.checked?glue.price*tubes:0);
      this.querySelector('[data-selection]').textContent=selected.quantity+' × '+selected.title+' · '+selected.quantity*selected.count+' '+this.config.text.selection;
      this.querySelector('[data-total]').textContent=this.config.text.total+' '+new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency,currencyDisplay:'code'}).format(price/100);
    }
    async add(event) {
      event.preventDefault();if(this.busy||!this.items.length)return;
      this.busy=true;this.button.disabled=true;this.status.textContent=this.config.text.adding;
      try{
        const response=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:this.items})});
        const body=await response.json();if(!response.ok)throw new Error(body.description||this.config.text.error);
        window.location.assign(this.dataset.cart);
      }catch(error){this.status.textContent=error.message||this.config.text.error;this.busy=false;this.update();}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["architectural-product"]) return;
  try {
    
if(!customElements.get('psh-material-product'))customElements.define('psh-material-product',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.form=this.querySelector('form');this.config=JSON.parse(this.querySelector('[data-config]').textContent);this.button=this.querySelector('button[type=submit]');this.status=this.querySelector('[data-status]');this.form.addEventListener('input',()=>this.update());this.form.addEventListener('submit',e=>this.add(e));this.update();}
 update(){const option=this.form.elements.namedItem('id').selectedOptions[0],q=Number(this.form.elements.namedItem('quantity').value),count=option.dataset.title==='Single'?1:Number((option.dataset.title.match(/Pack of (\d+)/)||[])[1]);this.withGlue=this.querySelector('[data-adhesive]')?.checked;this.tubes=Math.ceil(count*q/30);this.valid=option.dataset.available==='true'&&Number.isInteger(q)&&q>=1&&q<=100&&(!this.withGlue||(this.config.glue?.available&&Number.isFinite(this.tubes)));this.items=[{id:Number(option.value),quantity:q}];if(this.withGlue&&this.valid)this.items.push({id:this.config.glue.id,quantity:this.tubes});this.button.disabled=!this.valid||this.busy;const total=Number(option.dataset.price)*q+(this.withGlue&&this.valid?this.tubes*this.config.glue.price:0);this.querySelector('[data-total]').textContent=Number.isFinite(total)?new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency,currencyDisplay:'code'}).format(total/100):'';this.querySelector('[data-summary]').textContent=this.withGlue&&this.valid?this.tubes+' '+this.config.text.tubes:'';}
 async add(e){e.preventDefault();if(!this.valid||this.busy)return;this.busy=true;this.button.disabled=true;this.status.textContent=this.config.text.adding;try{const r=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:this.items})}),data=await r.json();if(!r.ok)throw Error(data.description||this.config.text.error);window.location.assign(this.dataset.cart);}catch(error){this.busy=false;this.status.textContent=error.message;this.update();}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
